import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './styles.scss';

import 'jquery/dist/jquery';
import 'bootstrap/dist/js/bootstrap.min';

import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';

import 'moment/locale/pt-br';

import { loadMessages, locale } from 'devextreme/localization';
import ptMessages from 'devextreme/localization/messages/pt.json';

import store from './store';

import Components from './components';

import * as serviceWorker from './serviceWorker';

loadMessages(ptMessages);
locale(navigator.language || navigator.browserLanguage);

ReactDOM.render(
  <Provider store={store}>
    <Components />
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
